<template>
  <el-dialog custom-class="medium-dialog" title="增加商品" :visible.sync="dialogFormVisible" center
             :close-on-click-modal="false"
             :append-to-body="true" @close="cloaseD"
  >
    <el-form >
      <div class="makeinvenMain" ref="makeinvenMain">
        <el-table
          :data="storetable"
          size="mini"
          stripe
          border
          style="width: 96%;">
          <el-table-column fixed
                           width="60"
                           label="序号"
                           align="center">
            <template slot-scope="scope">
              {{1+scope.$index}}
            </template>
          </el-table-column>
          <el-table-column
            prop="seedname"
            label="商品名称"
            align="left"
            header-align="center" :show-overflow-tooltip="true">
          </el-table-column>
          <el-table-column
            prop="goodyear"
            label="年份"
            align="left" width="60"
            header-align="center">
          </el-table-column>
          <el-table-column
            prop="costprice" v-if="showprice"
            label="单价"
            align="left" width="60"
            header-align="center">
          </el-table-column>
          <!--<el-table-column-->
          <!--prop="seedcode"-->
          <!--label="编码"-->
          <!--align="left"-->
          <!--header-align="center" :show-overflow-tooltip="true"-->
          <!--width="60">-->
          <!--</el-table-column>-->
          <el-table-column
            prop="MC"
            label="型号色号"
            align="left"
            header-align="center"
            width="180">
            <template slot-scope="scope">
              {{scope.row.MC}}
              <!--<el-select-->
                <!--v-model="scope.row.MC"-->
                <!--filterable-->
                <!--placeholder="请输入关键词" size="mini" @change="afterSelectSH(scope.row)" :default-first-option="true">-->
                <!--<el-option-->
                  <!--v-for="item in goodstable"-->
                  <!--:key="item.index"-->
                  <!--:label="item.name"-->
                  <!--:value="item.index">-->
                <!--</el-option>-->
              <!--</el-select>-->
            </template>
          </el-table-column>
          <el-table-column
            v-if="cangkuname"
            :label="cangkuname"
            align="left"
            width="80"
            header-align="center">
            <template slot-scope="scope">
              <el-tag v-if="scope.row.P>0&&scope.row.P>scope.row.storenum" type="danger">{{scope.row.storenum}}</el-tag>
              <span v-else>{{scope.row.storenum}}</span>
            </template>
          </el-table-column>
          <el-table-column
            v-if="cangkuname2"
            :label="cangkuname2"
            align="left"
            width="80"
            header-align="center">
            <template slot-scope="scope">
              {{scope.row.storenum2}}
            </template>
          </el-table-column>
          <el-table-column
            prop="P"
            label="数量"
            align="left"
            width="90"
            header-align="center">
            <template slot-scope="scope">
              <el-input-number   v-model="scope.row.P" :controls="false" @change="setTotalnum" @focus="focus($event)" style="width: 75px" size="mini"></el-input-number>
            </template>
          </el-table-column>
          <el-table-column
            label="合计"
            align="left" width="90" v-if="showprice"
            header-align="center">
            <template slot-scope="scope">
              {{scope.row.P&&scope.row.costprice?parseFloat(scope.row.P*scope.row.costprice).toFixed(2):''}}
            </template>
          </el-table-column>
          <el-table-column
            label="操作"
            align="left"
            width="70"
            header-align="center">
            <template slot-scope="scope">
              <i class="el-icon-remove-outline" style="font-size: 24px;cursor: pointer" @click="deleteFrame(scope.$index)"></i>
            </template>
          </el-table-column>
        </el-table>
        <el-select
          v-model="selMC" ref='addSelect' :multiple="true" :default-first-option="true" :automatic-dropdown="true" style="float: left;margin-left: 180px"
          filterable :remote-method="remoteMethod" remote
          placeholder="请输入关键词" size="mini" @change="addSelectSH" >
          <el-option
            v-for="item in goodstableoption"
            :key="item.index"
            :label="item.name"
            :value="item.index">
          </el-option>
        </el-select>
        <span style="float: left;margin-left: 40px">总数：<b>{{totalnumber}}</b></span><span style="float: left;margin-left: 20px" v-if="showprice">总价：<b>{{totalmoney}}</b></span>
        <!--<el-table-->
          <!--:data="addtable" :show-header="false"-->
          <!--size="mini"-->
          <!--stripe-->
          <!--border-->
          <!--style="width: 96%;margin-bottom: 300px">-->
          <!--<el-table-column fixed-->
                           <!--width="60"-->
                           <!--label="序号"-->
                           <!--align="center">-->
            <!--<template slot-scope="scope">-->
              <!--{{storetable.length+1}}-->
            <!--</template>-->
          <!--</el-table-column>-->
          <!--<el-table-column-->
            <!--prop="seedname"-->
            <!--label="商品名称"-->
            <!--align="left"-->
            <!--header-align="center" :show-overflow-tooltip="true">-->
            <!--<template slot-scope="scope">-->

            <!--</template>-->
          <!--</el-table-column>-->
          <!--<el-table-column-->
            <!--prop="goodyear"-->
            <!--label="年份"-->
            <!--align="left" width="60"-->
            <!--header-align="center">-->
            <!--<template slot-scope="scope">-->

            <!--</template>-->
          <!--</el-table-column>-->
          <!--<el-table-column-->
            <!--prop="costprice"-->
            <!--label="单价"-->
            <!--align="left" width="60"-->
            <!--header-align="center">-->
            <!--<template slot-scope="scope">-->

            <!--</template>-->
          <!--</el-table-column>-->
          <!--<el-table-column-->
            <!--prop="MC"-->
            <!--label="型号色号"-->
            <!--align="left"-->
            <!--header-align="center"-->
            <!--width="180">-->
            <!--<el-select-->
              <!--v-model="selMC" ref='addSelect' :multiple="true" :default-first-option="true" :automatic-dropdown="true"-->
              <!--filterable-->
              <!--placeholder="请输入关键词" size="mini" @change="addSelectSH" >-->
              <!--<el-option-->
                <!--v-for="item in goodstable"-->
                <!--:key="item.index"-->
                <!--:label="item.name"-->
                <!--:value="item.index">-->
              <!--</el-option>-->
            <!--</el-select>-->
          <!--</el-table-column>-->
          <!--<el-table-column-->
            <!--v-if="cangkuname"-->
            <!--:label="cangkuname"-->
            <!--align="left"-->
            <!--width="80"-->
            <!--header-align="center">-->
            <!--<template slot-scope="scope">-->
            <!--</template>-->
          <!--</el-table-column>-->
          <!--<el-table-column-->
            <!--v-if="cangkuname2"-->
            <!--:label="cangkuname2"-->
            <!--align="left"-->
            <!--width="80"-->
            <!--header-align="center">-->
            <!--<template slot-scope="scope">-->
            <!--</template>-->
          <!--</el-table-column>-->
          <!--<el-table-column-->
            <!--prop="P"-->
            <!--label="数量"-->
            <!--align="left"-->
            <!--width="90"-->
            <!--header-align="center">-->
            <!--<template slot-scope="scope">-->
              <!--{{totalnumber}}-->
            <!--</template>-->
          <!--</el-table-column>-->
          <!--<el-table-column-->
            <!--label="合计"-->
            <!--align="left" width="100"-->
            <!--header-align="center">-->
            <!--<template slot-scope="scope">-->
              <!--{{totalmoney}}-->
            <!--</template>-->
          <!--</el-table-column>-->
          <!--<el-table-column-->
            <!--label="操作"-->
            <!--align="left"-->
            <!--width="70"-->
            <!--header-align="center">-->
            <!--<template slot-scope="scope">-->

            <!--</template>-->
          <!--</el-table-column>-->
        <!--</el-table>-->
      </div>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button @click="cloaseD">关 闭</el-button>
      <el-button type="primary" @click="saveData" >确 定</el-button>&nbsp;
    </div>
  </el-dialog>
</template>


<script>
  import {getGoodsListWithStoreDetail} from '@/api/set/jxcresultstore'

  export default {
    name: 'MakeInventoryFrameAdd',
    msg: '增加商品',
    data() {
      return {
        dialogFormVisible: false,
        goodstable: [],//所有商品列表
        goodstableoption:[],
        storetable: [],
        cangkuname:'',
        cangkuname2:'',
        cangkuStore:[],
        cangkuStore2:[],
        selMC:'',
        totalnumber:0,
        totalmoney:0,
        showprice:false,
        addtable:[{id:-999,seedcode: "", seedname: "", M: "", C: "", P: 0, MC: ""}],
        idlist:0,
      }
    },
    methods: {
      setOption50() {
        this.goodstableoption = this.goodstable.filter((item, index) => {
          return index < 30;
        });
      },
      remoteMethod(query) {
        if (query !== '') {
          var arr = this.goodstable.filter(item => {
            return item.name.toLowerCase()
              .indexOf(query.toLowerCase()) > -1;
          }).slice(0, 30);
          this.goodstableoption = arr;
        } else {
          this.setOption50();
        }
      },
      setTotalnum(){
        this.totalnumber=0;
        this.totalmoney=0;
        for(let i in this.storetable){
          var row = this.storetable[i];
          if(row.P)
            this.totalnumber+=row.P;
          if(row.P && row.costprice)
            this.totalmoney += parseFloat(row.P) * parseFloat(row.costprice);
        }
        this.totalmoney = this.totalmoney.toFixed(2);
      },
      addSelectSH() {
        var i = this.selMC[0];
        // for (let i in this.goodstable) {
        //   if (this.goodstable[i].index ==this.selMC) {
        var newRow = {}
        newRow.MC = this.goodstable[i].name;
        newRow.M = this.goodstable[i].M;
        newRow.C = this.goodstable[i].C;
        newRow.seedcode = this.goodstable[i].seedcode;
        newRow.seedname = this.goodstable[i].seedname;
        newRow.goodyear = this.goodstable[i].goodyear;
        newRow.costprice = this.goodstable[i].costprice;
        newRow.P = 1;

        this.selMC = [];
        for (let j in this.storetable) {
          if (this.storetable[j].M == newRow.M && this.storetable[j].C == newRow.C && this.storetable[j].seedcode == newRow.seedcode) {
            this.$confirm('该商品再第' + (parseInt(j) + 1) + '行已经被输入了, 数量是否累加?', '提示', {
              confirmButtonText: '是',
              cancelButtonText: '否',
              type: 'warning'
            }).then(() => {
              this.storetable[j].P += 1;
              this.totalnumber += 1;
              if (newRow.costprice)
                this.totalmoney = (parseFloat(this.totalmoney)+ parseFloat(newRow.costprice)).toFixed(2);
            }).catch(() => {
            });
            return;
          }
        }

        this.totalnumber += 1;
        if (newRow.costprice)
          this.totalmoney = (parseFloat(this.totalmoney)+ parseFloat(newRow.costprice)).toFixed(2);
        if (this.cangkuname)
          this.getStore(newRow, 1);
        if (this.cangkuname2)
          this.getStore(newRow, 2);
        this.storetable.push(newRow);

        this.$nextTick(() => {
          this.$refs.makeinvenMain.scrollTop = this.$refs.makeinvenMain.scrollHeight;
        })
      },
      afterSelectSH(row) {
        for (let i in this.goodstable) {
          if (this.goodstable[i].index == row.MC) {
            row.M = this.goodstable[i].M;
            row.C = this.goodstable[i].C;
            row.seedcode = this.goodstable[i].seedcode;
            row.seedname = this.goodstable[i].seedname;
            row.costprice = this.goodstable[i].costprice;
            // row.P = 1;
            break;
          }
        }
        this.setTotalnum();
      },
      focus(event) {
        event.currentTarget.select();
      },
      deleteFrame(index) {
        this.storetable.splice(index, 1)
        this.setTotalnum();
      },
      addEmpty() {
        var ids=this.idlist;
        this.addtable.push({id:this.idlist,seedcode: "", seedname: "", M: "", C: "", P: 0, MC: ""})
        this.idlist++;
        return ids;
      },
      show(goodstable,cangkuinfo) {
        this.dialogFormVisible = true;
        this.idlist = 0;
        this.totalnumber=0;
        this.totalmoney=0;
        this.goodstable = []
        this.showprice=false;
        var ind = 0;
        var seedcodes = ','
        for (let i in goodstable) {
          var item = goodstable[i]
          seedcodes+=item.seedcode + ',';
          if(!this.showprice&&item.costprice>0)this.showprice=true;

          var color = item.color;
          if (color.indexOf(';') > -1) {
            var colors = color.split(';');
            for (let s in colors) {
              if (colors[s]) {
                var col = ''
                if (colors[s] && colors[s].length > 1 && colors[s].substring(0, 1) == '/') {
                  col = colors[s]
                } else {
                  col = '/' + colors[s];
                }
                var tablerow={
                  index: ind,
                  name: item.model + col,
                  categorycode: item.categorycode,
                  M: item.model,
                  C: colors[s],
                  seedcode: item.seedcode,
                  seedname: item.seedname,
                  goodyear: item.goodyear,
                  costprice:item.costprice,
                };
                this.goodstable.push(tablerow)
                ind++;
              }
            }
          } else {
            var col = ''
            if (item.color && item.color.length > 1 && item.color.substring(0, 1) == '/') {
              col = item.color
            } else {
              col = '/' + item.color;
            }
            this.goodstable.push({
              index: ind,
              name: item.model + col,
              categorycode: item.categorycode,
              M: item.model,
              C: item.color,
              seedcode: item.seedcode,
              seedname: item.seedname,
              goodyear: item.goodyear,
              costprice:item.costprice,
            })
            ind++;
          }
        }
        this.setOption50();
        this.storetable = [];
        if(cangkuinfo&&seedcodes!=',') {
          if (cangkuinfo.cangkucode) {
            this.cangkuname = cangkuinfo.cangkuname
            this.bindStore(cangkuinfo.cangkucode,seedcodes,1);
          }
          if (cangkuinfo.cangkucode2) {
            this.cangkuname2 = cangkuinfo.cangkuname2
            this.bindStore(cangkuinfo.cangkucode2,seedcodes,2);
          }
        }

        this.$nextTick(() => {
          setTimeout(() => {
            this.$refs.addSelect.focus();
          }, 200)
        })

        // for (let i = 0; i < 1; i++) {
        //   this.addEmpty();
        // }
      },
      getStore(row,storeIndex) {
        var storeData = storeIndex == 1 ? this.cangkuStore : this.cangkuStore2;
        var canusesub=0;
        try {
          var packages = '{"M":"' + row.M + '","C":"' + row.C + '"}';
          var infoGoods = storeData.filter(o => o.seedcode == row.seedcode && o.packagesize == packages);//采购需求中明细

          for (let orderIndex in infoGoods) {
            var storeRow = infoGoods[orderIndex];
            var canuse = storeRow.subtractnum - storeRow.deliverying + storeRow.transfernum;//库存数量
            if (canuse == undefined) {
              canuse = 0
            }
            canusesub += canuse;
          }
        } catch (ex) {

        }
        if(storeIndex == 1){
          row.storenum=canusesub;
        }else{
          row.storenum2=canusesub;
        }
      },
      bindStore(cangkucode,seedcodes,storeindex) {
        let yearnow = new Date().getFullYear()
        let monthnow = new Date().getMonth() + 1
        getGoodsListWithStoreDetail({
          seedcode: seedcodes,//产品分类（单选）
          cangkucode: cangkucode,//选择的仓库（单选）
          minyear: yearnow,
          minmonth: monthnow,
          maxyear: yearnow,
          maxmonth: monthnow,
          nostock: 1, nobuynum: '1', nolimit: '1'
        }).then(resStore => {
          if(storeindex==1) {
            this.cangkuStore = resStore.data.obj;
            for(let i in  this.storetable){
              this.getStore(this.storetable[i],1)
            }
          }
          else {
            this.cangkuStore2 = resStore.data.obj
            for(let i in  this.storetable){
              this.getStore(this.storetable[i],2)
            }
          }
        }).catch((error) => {
          console.log(error)
        });
      },
      cloaseD(){
        this.dialogFormVisible=false;
        this.$emit('afterSelect',[]);
      },
      saveData() {
        //合并相同的
        var arr=[]
        for (let i in this.storetable) {
          var item = this.storetable[i];
          if (item.seedcode && item.P && item.P != 0) {
            arr.push(item);
          }
        }
        this.dialogFormVisible=false;
        this.$emit('afterSelect',arr);
      },
    },
    components: {
    },
    mounted() {
    },
  }
</script>

<style scoped>
  .makeinvenMain{
    float: left;
    width: 100%;
    overflow:auto;
    height:calc(96vh - 149px) ;
  }
</style>



// WEBPACK FOOTER //
// src/components/warehouse/MakeInventoryFrameAdd.vue